module.exports = __webpack_public_path__ + "static/media/reset_logo.458d319b.jpg";